import { useContext } from 'react';
import { ContextApi } from 'react-uforms';
import { Question } from '@ch/common/types/data';
import { useDropdown } from './use-dropdown';

export const useQuizDescription = ({ conditions, file }: Question) => {
  const { rawOptions } = useDropdown({ file });
  const { getAllValues } = useContext(ContextApi);
  const parents = conditions.map(({ parent }) => parent?.map(({ identifier: parentId }) => parentId)).flat();
  const values = Object.entries(getAllValues()).filter(([key]) => parents.includes(key));
  const item = rawOptions.find(({ value: optionValue }) => values.find(([, value]) => value === optionValue));

  return {
    item,
  };
};
